export default __webpack_public_path__ + "static/media/logo_comp.99cf7655.jpg";